import { render, staticRenderFns } from "./UnreadBlock.vue?vue&type=template&id=b430bb12&scoped=true&"
import script from "./UnreadBlock.vue?vue&type=script&lang=js&"
export * from "./UnreadBlock.vue?vue&type=script&lang=js&"
import style0 from "./UnreadBlock.vue?vue&type=style&index=0&id=b430bb12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b430bb12",
  null
  
)

component.options.__file = "UnreadBlock.vue"
export default component.exports